import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'brazilianCurrency',
})
export class BrazilianCurrencyPipe implements PipeTransform {
  constructor(private readonly currencyPipe: CurrencyPipe) {}
  transform(value: number | null | undefined): string {
    if (!value) return 'R$ 0,00';
    const item = this.currencyPipe.transform(`${value}`, 'BRL', 'symbol');
    if (!item) return 'R$ 0,00';
    let currency = item.replace('R$', 'R$ ')
    currency = currency.replaceAll('.','-');
    currency = currency.replaceAll(',','_');
    currency = currency.replaceAll('_','.');
    currency = currency.replaceAll('-',',');
    currency = currency[0] == ',' ? currency.replace(',', '-') : currency

    return currency
  }
}
